import { postRequest } from "@/assets/utils/api";
import { rejects } from "assert";
// 获取url的参数；
export const getQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search.substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]); //返回解码参数值
  return null; //返回参数值
};
//添加缓存；
export const setData = (
  openid,
  nickname,
  avatar,
  sex,
  unionid,
  token,
  userID
) => {
  localStorage.setItem("openid", openid);
  localStorage.setItem("nickname", nickname);
  localStorage.setItem("avatar", avatar);
  localStorage.setItem("sex", sex);
  localStorage.setItem("unionid", unionid);
  if (token) {
    localStorage.setItem("user_id", userID);
    localStorage.setItem("token", token);
  } else {
    localStorage.setItem("user_id", 0);
    localStorage.setItem("token", 0);
  }
};
// 获取openid;
export const openId = () => {
  // return o_kTswUOZBUXKBOQlZG2TI7P5bIo
  if (localStorage.getItem("openid")) {
    return localStorage.getItem("openid");
  } else {
    return false;
  }
};
// 删除所有的缓存
export const removeStorage = () => {
  localStorage.removeItem("user_id");
  localStorage.removeItem("token");
  localStorage.removeItem("openid");
  localStorage.removeItem("avatar");
  localStorage.removeItem("nickname");
  localStorage.removeItem("attention");
  localStorage.removeItem("lastTime");
  localStorage.removeItem("sex");
  localStorage.removeItem("unionid");
};
export const isLogin = () => {
  // return true
  if (localStorage.getItem("openid")) {
    return true;
  } else {
    return false;
  }
};
export const BaseStorage = () => {
  if (
    localStorage.getItem("user_id") &&
    localStorage.getItem("token") &&
    localStorage.getItem("openid")
  ) {
    return {
      user_id: localStorage.getItem("user_id"),
      token: localStorage.getItem("token"),
    };
  } else {
    return false;
  }
};
export const isBindPhone = () => {
  if (localStorage.getItem("token") && localStorage.getItem("token") != 0) {
    return true;
  } else {
    return false;
  }
};

export const checkPhone = (that, val, data) => {
  return new Promise((resolve, reject) => {
    if (!isBindPhone()) {
      if (val) {
        resolve(false);
      } else {
        // if (data) {
        //   that.$bindPhone({
        //     opts: () => {
        //       that.gotoAdver(data);
        //     }
        //   })
        // } else {
        // that.$bindPhone({
        //   opts: () => { }
        // })
        // }
        that
          .postRequest({
            service: "App.User.LoginByOpenId",
            openid: localStorage.getItem("openid"),
            unionid: localStorage.getItem("unionid")
              ? localStorage.getItem("unionid")
              : "",
          })
          .then((res) => {
            if (res.data.ret == 200) {
              var data = res.data.data;
              localStorage.setItem("nickname", data.nickname);
              localStorage.setItem("token", data.token);
              localStorage.setItem("user_id", data.user_id);
              localStorage.setItem("avatar", data.avatar);
              resolve(true);
            } else {
              if (data) {
                that.$bindPhone({
                  opts: () => {
                    that.gotoAdver(data);
                  },
                });
              } else {
                that.$bindPhone({
                  opts: () => {},
                });
              }
              resolve(false);
            }
          });
      }
    } else {
      resolve(true);
    }
  });
};
export const refreshToken = (that, showPhone) => {
  if (localStorage.getItem("user_id") == 0 ||localStorage.getItem("user_id")==null) {
    if (localStorage.getItem("openid")) {
      return new Promise((resolve, reject) => {
        that
          .postRequest({
            service: "App.User.LoginByOpenId",
            openid: localStorage.getItem("openid"),
            unionid: localStorage.getItem("unionid")
              ? localStorage.getItem("unionid")
              : "",
          })
          .then((res) => {
            if (res.data.ret == 200) {
              var data = res.data.data;
              localStorage.setItem("nickname", data.nickname);
              localStorage.setItem("token", data.token);
              localStorage.setItem("user_id", data.user_id);
              localStorage.setItem("avatar", data.avatar);
              resolve(true);
            } else {
              // if (showPhone) {
              //   that.$bindPhone();
              // }
              resolve(false);
            }
          });
      });
    } else {
      return false;
      // if (showPhone) {
      //   that.$bindPhone();
      // }
    }
  } else {
    return true;
  }
};
// export const refreshToken = that => {
//   return new Promise((resolve, reject) => {
//     that
//       .postRequest({
//         service: "App.User.LoginByOpenId",
//         openid: localStorage.getItem("openid"),
//         unionid: localStorage.getItem("unionid")
//           ? localStorage.getItem("unionid")
//           : ""
//       })
//       .then(res => {
//         if (res.data.ret == 200) {
//           var data = res.data.data;
//           localStorage.setItem("nickname", data.nickname);
//           localStorage.setItem("token", data.token);
//           localStorage.setItem("user_id", data.user_id);
//           localStorage.setItem("avatar", data.avatar);
//           resolve(true);
//         } else {
//           resolve(false);
//         }
//       });
//   });
// };
export const onBridgeReady = () => {
  WeixinJSBridge.call("hideOptionMenu");
};
export const noshare = () => {
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};

export const getOpenId = () => {
  var APPID = apiConfig().APPID;
  var REDIRECT_URI = apiConfig().loginUrl;
  var url =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
    APPID +
    "&redirect_uri=" +
    encodeURIComponent(REDIRECT_URI) +
    "&response_type=code&scope=snsapi_base&state=999#wechat_redirect";
  location.href = url;
};
// export const loginYouZan=()=>{
//     postRequest({service:'App.YouZan_User.Login'}).then(res=>{

//     })
// }
export const login = () => {
  console.log(
    getQueryString("state") == "999",
    getQueryString("state") == "999"
  );
  if (getQueryString("state") == "999") {
    console.log(
      getQueryString("state") == "999",
      getQueryString("state") == "999"
    );
    if (getQueryString("code")) {
      return new Promise((resolve, reject) => {
        postRequest({
          service: "WxMessage.login",
          wx_code: getQueryString("code"),
        }).then((res) => {
          if (res.data.ret == 200) {
            // 当status==0的时候说明没有获取到用户信息；
            if (res.data.data.status == 0) {
              var APPID = apiConfig().APPID;
              var REDIRECT_URI = apiConfig().loginUrl;
              location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                APPID +
                "&redirect_uri=" +
                encodeURIComponent(REDIRECT_URI) +
                "&response_type=code&scope=snsapi_userinfo&state=666#wechat_redirect";
            } else if (res.data.data.status == 1) {
              resolve(res);
            } else if (res.data.data.status == 2) {
              resolve(res);
            } else {
              console.log(res.data.data);
              alert(res.data.data);
            }
          } else {
            getOpenId();
          }
        });
      });
    }
  } else if (getQueryString("state") == "666") {
    return new Promise((resolve, reject) => {
      postRequest({
        service: "WxMessage.login_info",
        wx_code: getQueryString("code"),
      }).then((res) => {
        resolve(res);
      });
    });
  } else {
    return new Promise((resolve, reject) => {
      resolve(false);
      getOpenId();
    });
  }
};
export const pageScroll = (function() {
  const fn = function(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  let islock = false;

  return {
    lock(el) {
      if (islock) return;
      islock = true;
      (el || document).addEventListener("touchmove", fn, { passive: false });
    },
    unlock(el) {
      islock = false;
      (el || document).removeEventListener("touchmove", fn);
    },
  };
})();
export const test = function(t, fun) {
  fun.call(t);
};
var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
var browser = {
  versions: (function() {
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      trident: u.indexOf("Trident") > -1, //IE内核
      presto: u.indexOf("Presto") > -1, //opera内核
      webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
      gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Adr") > -1, //android终端
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq", //是否QQ
    };
  })(),
  language: (navigator.browserLanguage || navigator.language).toLowerCase(),
};
export { browser };
export const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isUpdataName = () => {
  return new Promise((resolve, reject) => {});
};
// 检查是否更新昵称和头像
export const checkUpdataMinxin = {
  methods: {
    isUpdataName() {
      return new Promise((resolve) => {
        this.postRequest({ service: "App.User.IsUpdNameAvatar" }).then(
          (res) => {
            var data = res.data.data;

            if (data.nicknameisupd && data.nicknameisupd) {
              //
              resolve(true);
            } else {
              localStorage.setItem(
                "avatornameFlag",
                JSON.stringify(res.data.data)
              );
              this.$router.push({
                path: "/updatabase",
              });
              resolve(false);
            }
          }
        );
      });
    },
  },
};
export const PwdMinxin = {
  methods: {
    confirmSetpwd() {
      this.$confirm({
        title: "提示",
        mes: "您未设置支付密码，是否要去设置",
        opts: [
          {
            txt: "取消",
            color: "#ffbc00",
            callback: () => {},
          },
          // {
          //   txt: "确定",
          //   stay: true,
          //   color: "#ffbc00",
          //   callback: () => {
          //     var Element = document.getElementById("confirmContent");
          //     Element.parentNode.removeChild(Element);
          //     this.$router.push({
          //       path: "/selfsafe",
          //       query: {
          //         type: "new"
          //       }
          //     });
          //   }
          // }
        ],
      });
    },
  },
};

function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString()) +
    ";path=/;domain=nbthinking.com";
}

export const gotoAdver = (item, that, fromId) => {
  console.log(fromId);
  var key = item.types;
  switch (key) {
    case "book":
      that.$router.push({
        path: "/course",
        query: {
          bookid: item.param,
          id: item.param,
        },
      });
      break;
    case "zl":
      that.$router.push({
        path: "/excellentCourse",
        query: {
          id: item.param,
          fromid: fromId,
        },
      });

      break;
    case "link":
      if (item.needuserinfo) {
        location.href = item.param + "?source=wx";
        let obj = {
          nickname: localStorage.getItem("nickname"),
          avatar: localStorage.getItem("avatar"),
        };
        if (localStorage.getItem("user_id")) {
          obj.user_id = localStorage.getItem("user_id");
        } else {
          obj.user_id = -1;
        }
        setCookie("userInfo", JSON.stringify(obj));
      } else {
        location.href = item.param;
      }

      break;
    case "youzan":
      // that.$poster.open();
      break;
  }
};
export const weixinshare = (title, des, link, fridendTitle) => {
  var url = window.location.href;
  var innerUrl = url.split("#")[0];
  var that = this;
  return new Promise((resolve, reject) => {
    postRequest({
      service: "App.WxMessage.GetJssdkPara",
      url: innerUrl,
    }).then((res) => {
      if (res.data.ret == 200) {
        var data = res.data.data;

        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp + "", // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareWeibo",
            "closeWindow",
          ], // 必填，需要使用的JS接口列表
        });
        resolve("ok");
        wx.ready(function() {
          wx.updateAppMessageShareData({
            title: title, // 分享标题
            desc: des, // 分享描述
            link: link,
            imgUrl: apiConfig().shareImage,
            success: function() {
              // 用户点击了分享后执行的回调函数
            },
          });
          wx.updateTimelineShareData({
            title: fridendTitle ? fridendTitle : title,
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: apiConfig().shareImage, // 分享图标
            success: function() {
              // 设置成功
            },
          });
          wx.onMenuShareWeibo({
            title: title, // 分享标题
            desc: des, // 分享描述
            link: link,
            imgUrl: apiConfig().shareImage,
            success: function() {
              // 用户确认分享后执行的回调函数
            },
            cancel: function() {
              // 用户取消分享后执行的回调函数
            },
          });
        });
      }
    });
  });
};

export const forbidShare = () => {
  function onBridgeReady() {
    WeixinJSBridge.call("hideOptionMenu");
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};
export const isweixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  }
  return false;
};
export const downAppMixin = {
  methods: {
    downApp() {
      location.href = "https://web.newmyss.nbthinking.com/share/download.html";
    },
  },
};
export const WXpayMixin = {
  methods: {
    phonesuccess() {
      this.isusepay("usepay");
    },
    async getselfpay(obj) {
      let res = await this.postRequest(obj);
      let data = res.data;

      if (data.ret == 200) {
        return data.data;
      }
    },
    gopay() {
      if (isweixin()) {
        if (isLogin()) {
          if (parseInt(localStorage.getItem("user_id")) > 0) {
            this.submitpay();
          } else {
            this.showPhone = true;
          }
        } else {
          this.$router.push({
            path: "/wlogin",
          });
        }
      } else {
        this.$confirm({
          title: "提示",
          mes: "请在微信中打开",
          opts: [
            {
              txt: "我知道了",
              stay: true,
              color: "#ffbc00",
              callback: () => {
                var Element = document.getElementById("confirmContent");
                Element.parentNode.removeChild(Element);
                pageScroll.unlock();
              },
            },
          ],
        });
      }
    },
    async WXpay(obj) {
      if (!this.payStatus) {
        return;
      }
      this.payStatus = false;

      let res = await this.postRequest(obj);
      if (res.data.ret == 200) {
        var data = res.data.data;
        // this.payStatus=true;
        // return 'ok'
        let resdata = await this.callpay(
          data.appid,
          data.nonce_str,
          data.prepay_id,
          data.paySgin,
          data.timestamp + ""
        );
        return resdata;
      } else {
        this.$dialog.toast({
          mes: res.data.msg,
          timeout: 1500,
        });
      }
    },
    async callpay(appid, nonceStr, prepayId, sign, timeStamp, active_time) {
      var that = this;
      return new Promise((resolve, reject) => {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
            return true;
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", jsApiCall);
            document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
            return true;
          }
        } else {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: "prepay_id=" + prepayId,
              signType: "MD5",
              paySign: sign,
            },
            function(res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                that.$dialog.toast({
                  mes: "支付成功",
                  timeout: 1500,
                  icon: "success",
                });

                that.payStatus = true;
                resolve("ok");
                return true;
              } else {
                alert("支付失败");
                that.payStatus = true;
                reject("false");
                return false;
              }
            }
          );
        }
      });
    },
  },
};
export const HookMinxin = {
  methods: {
    async hookHand(txt) {
      let mes = "";
      if (txt) {
        mes = txt;
      } else {
        mes = "下载APP，开始读书";
      }
      this.$confirm({
        title: "提示",
        mes: mes,
        opts: [
          {
            txt: "等一等",
            color: "#e6e6e6",
            callback: () => {},
          },
          {
            txt: "马上下载",
            stay: true,
            color: "#ffbc00",
            callback: () => {
              var Element = document.getElementById("confirmContent");
              Element.parentNode.removeChild(Element);
              pageScroll.unlock();
              window.location.href =
                "https://a.app.qq.com/o/simple.jsp?pkgname=auntschool.think.com.aunt";
            },
          },
        ],
      });
      return true;
    },
  },
};
